const DirectionDownIcon = (props) => (
	<svg 
		xmlns="http://www.w3.org/2000/svg" 
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props} 
	>
		<path d="M7 4L7 10M7 10L3 6M7 10L11 6" strokeWidth="2"/>
	</svg>
)

export default DirectionDownIcon